import React from "react";
import "./SimilarJobsItem.scss";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import StringUtils from "../../../utils/StringUtils";
import PlaceIcon from "@material-ui/icons/Place";
import BusinessIcon from "@material-ui/icons/Business";
import useShowLoader from "../../common/loading-widgets/useShowLoader";
import { useHistory } from "react-router-dom";
import * as ROUTES from "../../../constants/routes";
import RouterUtils from "../../../utils/RouterUtils";
import ActionLink from "../../common/widgets/ActionLink";
import useTranslationLanding from "../../landing/useTranslationLanding";
import TypeUtils from "../../../utils/TypeUtils";

export default function JobSearchItemLanding(props) {
  const history = useHistory();

  const onClickViewAll = () => {
    history.push(
      RouterUtils.injectParamsInRoute(ROUTES.RECRUITER_JOB, {
        jobId: job._id,
      })
    );
  };

  const { t, loading: tLoading } = useTranslationLanding();
  useShowLoader(tLoading, "JobSearchItemLanding");

  const { item: job } = props;

  const addressLine = TypeUtils.arrayRemoveNullOrEmpty([job.city, job.state, job.country])
    .join(", ");

  // RENDER

  return (
    <Card className="SimilarJobsItem" id={job._id}>
      <Card.Body className="job-search-card">
        <Row className="job-search-row-container">
          <Col className="jobInformation">
            <Row>
              <Col>
                <ActionLink onClick={onClickViewAll} className="job-link">
                  {job.title}
                </ActionLink>
              </Col>
            </Row>
            <Row className="logo-row">
              <Col className="icon-col-container">
                <Row>
                  <Col className="icon-col">
                    <BusinessIcon />
                  </Col>
                  <Col>{job.organization && job.organization.company}</Col>
                </Row>
              </Col>
              {!StringUtils.isNullOrEmpty(addressLine) && (
                <>
                  <Col className="icon-col-container">
                    <Row>
                      <Col className="icon-col">
                        <PlaceIcon />
                      </Col>
                      <Col>{addressLine}</Col>
                    </Row>
                  </Col>
                </>
              )}
            </Row>
          </Col>
          <Col className="last-col">
            <Row>
              <Col className="commission-title-col">
                {t("landing:landing_job_commission_title")}
              </Col>
            </Row>
            <Row>
              <Col className="commission-col">
                {t("landing:landing_job_details_commission_amount", {
                  amount: job.commission,
                })}
              </Col>
            </Row>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}
